/* @flow */

import React from 'react';
import Immutable from 'immutable';
import { Segment, Message, Item } from 'semantic-ui-react';
import DocumentItem from './DocumentItem';
import { reorderElements, enforceElementsOrder } from 'utils/ordering';
import type { MySpaceDocument } from '../types';

type Props = {
  docs: List<MySpaceDocument>,
  onUpdate: (documents: List<MySpaceDocument>) => void,
};

const updateDocuments = docs => updateFunction =>
  updateFunction(Immutable.Map(docs.map(b => [b.order, b])).toList());

const mergeDocuments = (docs, updated) =>
  updateDocuments(docs)(map =>
    map.update(updated.order, b => ({
      ...b,
      ...updated,
    }))
  );

const removeDocument = (docs, toDelete) =>
  updateDocuments(docs)(map => map.remove(toDelete.order));

const MySpaceDocuments = ({ docs, onUpdate }: Props) => {
  const renderContents = () => {
    if (docs && docs.size) {
      const updateDoc = (doc: MySpaceDocument) =>
        onUpdate(mergeDocuments(docs, doc));

      const reorderDocs = (doc: MySpaceDocument, order: number) => {
        const reordered = reorderElements(docs, doc, order);
        onUpdate(reordered);
      };

      const deleteDoc = (doc: MySpaceDocument) => {
        const reordered = enforceElementsOrder(removeDocument(docs, doc));
        onUpdate(reordered);
      };

      return (
        <Item.Group divided>
          {docs.map(d => (
            <DocumentItem
              key={d.id}
              doc={d}
              docs={docs}
              onUpdate={updateDoc}
              onOrderChanged={reorderDocs}
              onDelete={deleteDoc}
            />
          ))}
        </Item.Group>
      );
    }

    return <Message icon="info" header="Aucun document" />;
  };

  return <Segment attached="bottom">{renderContents()}</Segment>;
};

export default MySpaceDocuments;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/MySpaceDocuments.js